// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"55bd2cc0","625":"55bd2cc0","737":"55bd2cc0","787":"55bd2cc0","952":"55bd2cc0"}[chunkId] + ".chunk.css";
};